// extracted by mini-css-extract-plugin
module.exports =  {"viewRoot":"View-module__viewRoot--ZrTa0"};